var _path, _path2, _path3, _path4;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgAddToCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0751 17.5496C15.8207 17.5496 16.4251 16.9452 16.4251 16.1996C16.4251 15.454 15.8207 14.8496 15.0751 14.8496C14.3295 14.8496 13.7251 15.454 13.7251 16.1996C13.7251 16.9452 14.3295 17.5496 15.0751 17.5496Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.975 17.5496C7.72058 17.5496 8.325 16.9452 8.325 16.1996C8.325 15.454 7.72058 14.8496 6.975 14.8496C6.22942 14.8496 5.625 15.454 5.625 16.1996C5.625 16.9452 6.22942 17.5496 6.975 17.5496Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.225098 1.34922C0.225098 0.852162 0.628041 0.449219 1.1251 0.449219H4.07055C4.49804 0.449219 4.86654 0.749928 4.95227 1.16873L5.5419 4.04913L5.91036 5.84913L6.92599 10.8106C6.95027 10.9301 7.01762 11.0418 7.12166 11.1237C7.22613 11.206 7.35998 11.2517 7.49987 11.2491L7.51673 11.249H14.2242L14.241 11.2491C14.3809 11.2517 14.5148 11.206 14.6193 11.1237C14.7226 11.0424 14.7897 10.9317 14.8144 10.8132L15.7826 5.84913C16.0001 4.04913 16.5802 4.04913 16.8751 4.04913C17.144 4.04913 17.3988 4.16935 17.5697 4.37688C17.7407 4.58441 17.8099 4.85751 17.7585 5.12142L16.5789 11.169C16.4685 11.7124 16.167 12.1962 15.7325 12.5381C15.301 12.8778 14.7647 13.0571 14.2167 13.049H7.52418C6.97619 13.0571 6.43991 12.8778 6.00838 12.5381C5.57408 12.1963 5.27262 11.7127 5.16214 11.1695L3.9331 5.16551C3.92741 5.14245 3.9226 5.11905 3.91873 5.09533L3.33612 2.24922H1.1251C0.628041 2.24922 0.225098 1.84627 0.225098 1.34922Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8501 4.07422V1.94922H11.6001V4.07422H13.7251V5.82422H11.6001V7.94922H9.8501V5.82422H7.7251V4.07422H9.8501Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCart);
export default __webpack_public_path__ + "static/media/add_to_cart.6308d174d2e3c0f71356e998b5d22b61.svg";
export { ForwardRef as ReactComponent };